import * as serviceworker from '@losslessone_private/lele-serviceworker';
import * as domtools from '@designestate/dees-domtools';

import { html, render } from '@designestate/dees-element';
import '@losslessone_private/lele-catalog';

import * as state from './state/accountstate.js';

import './elements/index.js';
import './views/index.js';

const run = async () => {
  const domtoolsInstance = await domtools.DomTools.setupDomTools();
  domtools.elementBasic.setup();
  domtoolsInstance.setWebsiteInfo({
    metaObject: {
      title: 'workspace.global',
      description: 'manage your w.g account',
      canonicalDomain: 'https://account.workspace.global',
      ldCompany: {
        name: 'Task Venture Capital GmbH',
        status: 'active',
        contact: {
          address: {
            name: 'Task Venture Capital GmbH',
            city: 'Bremen',
            country: 'Germany',
            houseNumber: '16',
            postalCode: '28213',
            streetName: 'Karl-Ferdinand-Braun-Str.5',
          },
          description: 'work',
          name: 'Task Venture Capital GmbH',
          type: 'company',
          facebookUrl: 'https://www.facebook.com/losslesscom',
          twitterUrl: 'https://twitter.com/losslesscom',
          website: 'https://task.vc',
          phone: '+49 421 989707 60',
        },
        closedDate: null,
        foundedDate: {
          day: 1,
          month: 1,
          year: 2014,
        },
      },
    },
  });

  const serviceWorker = serviceworker.getServiceWorker();

  const mainTemplate = html`
    <style>
      body {
        margin: 0px;
        height: 100vh;
        overflow: hidden;
        --lelecv-pagewidth: calc(100vw - 16px);
      }
    </style>
    <lele-logingate .loggedIn=${true} .leleReceptionClient=${state.receptionClient}>
      <lele-accountcontent></lele-accountcontent>
    </lele-logingate>
  `;

  render(mainTemplate, document.body);
};

run();
